import { render, staticRenderFns } from "./WorkCentersManagementPage.vue?vue&type=template&id=d41c5736&scoped=true&"
import script from "./WorkCentersManagementPage.vue?vue&type=script&lang=js&"
export * from "./WorkCentersManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkCentersManagementPage.vue?vue&type=style&index=0&id=d41c5736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41c5736",
  null
  
)

export default component.exports